import './Chip.css'

const Chip = ({ children, active, onClick, multiSelect = false }) => {
  return (
    <button
      className={`chip ${active ? 'active' : ''}`}
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default Chip

